import { formatInvestor } from 'Util';

const InvestorSummary = ({ data }) => {

  function renderingComment(title, val) {
    return (
      <div className="flex">
        <span>{title}</span>
        <span><strong className={val > 0 ? "txt_red" : val < 0 ? "txt_blue" : ""}>{formatInvestor(val)}</strong> {val > 0 ? "매수" : val < 0 ? "매도" : ""}</span>
      </div>
    )
  }

	return (
    <div className="text">
      <dl>
        <dt>국내기관</dt>
        <dd>
          {renderingComment('주간 증감', data.INSTITUTION_W)}
          {renderingComment('월간 증감', data.INSTITUTION_M)}
        </dd>
      </dl>
      <dl>
        <dt>외국인</dt>
        <dd>
          {renderingComment('주간 증감', data.FOREIGN_W)}
          {renderingComment('월간 증감', data.FOREIGN_M)}
        </dd>
      </dl>
    </div>
  );
}

export default InvestorSummary;
